<section class="dialog-title">
  <div [ngClass]="{ 'wrap-title': wrapTitle }" [innerHTML]="dialogTitle"></div>

  <button
    *ngIf="isCloseIconVisible"
    class="close-button"
    tabindex="-1"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon class="close-icon" [svgIcon]="'close-icon'"></mat-icon>
  </button>
</section>

<section class="dialog-content-container">
  <ng-content></ng-content>
</section>
